/* eslint-disable react/prop-types */
// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { CommentsList } from './comments-list';
import { CommentAdd } from './comment-add';
import { commentAddChanged, commentInsertSaga, commentDeleteSaga, commentUpdateSaga } from '../../reducers/comments';
import { getQueueSelector } from '../../selectors/queue-selectors';
import * as R from 'ramda';

export function $Comments(props) {
  const { ticketUUID, ticketNumber, comments } = props;
  const filteredComments = ticketUUID ? R.filter((c) => c.ticketUUID === ticketUUID)(comments) : comments;
  return (
    <section>
      <section>
        <CommentAdd
          comment={props.commentToAdd}
          simpleView={props.simpleView}
          ticketNumber={ticketNumber}
          ticketUUID={ticketUUID}
          onCommentInsert={props.handleCommentInsert}
          onChange={props.handleCommentAddChanged}
        />
      </section>
      <section>
        <CommentsList
          simpleView={props.simpleView}
          comments={filteredComments}
          onCommentDelete={(commentId) => props.handleCommentDelete(commentId)}
          onCommentUpdate={(comment) => props.handleCommentUpdate(comment)}
        />
      </section>
    </section>
  );
}

function mapStateToProperties(state) {
  return {
    selectedQueue: getQueueSelector(state.queues.selectedQueueId)(state.queues.connectedQueues),
    comments: state.comments.items,
    commentToAdd: state.comments.commentToAdd
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleCommentAddChanged: (comment) => dispatch(commentAddChanged(comment)),
    handleCommentInsert: (comment) => dispatch(commentInsertSaga(comment)),
    handleCommentDelete: (commentId) => dispatch(commentDeleteSaga(commentId)),
    handleCommentUpdate: (comment) => dispatch(commentUpdateSaga(comment))
  };
}

export const Comments = connect(mapStateToProperties, mapDispatchToProps)($Comments);
